module.exports = __webpack_public_path__ + "static/media/2DGACM7.35e553be.jpg";